import { useDispatch, useSelector } from "react-redux";
import {
  getAllFunctionalities,
  getAllSuperAdminConfigurations,
  insertFuncionalities,
  resetState,
  updateFunctionalities,
  geAllInstitutions,
  setOffset,
  setPage,
  setPerPage,
} from "../store/configuration";

export default function useSuperAdminConfiguration() {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.configuration.loading);
  const allfunctionalitiesData = useSelector(
    (state) => state.configuration.allfunctionalities.data
  );
  const institutionsData = useSelector(
    (state) => state.configuration.institutions.data
  );
  const superAdminConfigurationsData = useSelector(
    (state) =>
      state.configuration.superAdminConfigurations?.data
        ?.superAdminConfigurations
  );
  const superAdminConfigurationsLoading = useSelector(
    (state) => state.configuration.superAdminConfigurations?.update.loading
  );
  const superAdminConfigurationsTotalNoOfRecords = useSelector(
    (state) =>
      state.configuration.superAdminConfigurations?.data?.totalRecords
        ?.totalNoOfRecords || 0
  );
  
  const page = useSelector((state) => state.configuration?.page);
  const perPage = useSelector((state) => state.configuration?.perPage);
  const offset = useSelector((state) => state.configuration?.offset);
 

  const setOffsetAction = (params) => dispatch(setOffset(params));
  const setPerPageAction = (params) => dispatch(setPerPage(params));
  const setPageAction = (params) => dispatch(setPage(params));

  const getAllFunctionalitiesAction = (params) =>
    dispatch(getAllFunctionalities(params));

  const geAllInstitutionsAction = (params) =>
    dispatch(geAllInstitutions(params));
  const getAllSuperAdminConfigurationsAction = (params) =>
    dispatch(getAllSuperAdminConfigurations(params));
  const insertFuncionalitiesAction = (params) =>
    dispatch(insertFuncionalities(params));
  const updateFunctionalitiesAction = (params) =>
    dispatch(updateFunctionalities(params));

  return {
    // state
    loading,
    allfunctionalitiesData,
    superAdminConfigurationsData,
    superAdminConfigurationsTotalNoOfRecords,
    superAdminConfigurationsLoading,
    institutionsData,
    
    page,
    perPage,
    offset,

    // actions
    setOffsetAction,
    setPerPageAction,
    setPageAction,
    
    getAllFunctionalitiesAction,
    getAllSuperAdminConfigurationsAction,
    insertFuncionalitiesAction,
    updateFunctionalitiesAction,
    geAllInstitutionsAction,
  };
}
